module.exports = __webpack_public_path__ + "img/sjzw.e137c256.png";